import styled, { css } from 'styled-components';
import { PRIMARY_COLOR, SECONDARY_COLOR_6, SECONDARY_COLOR_1, START_PAGE_COLOR_DARK } from '../const/color';
import {
  FAMILY_FONT_CONTROL,
  TITLE_SIZE_1,
  TITLE_SIZE_2,
  TITLE_SIZE_3,
  TITLE_SIZE_4,
  TITLE_SIZE_5
} from '../const/text';
import { Button } from './Global';
import { CONTAINER_PADDING, ResponsiveH, ResponsiveW } from '../const/sizes';
import { device } from '../const/device';

export const Container = styled.div`
  display: flex;
  @media (${device.tablet}) {
    flex-direction: column-reverse;
  }
  @media (${device.mobileL}) {
    min-height: calc(100% - 32px);
  }
`;

export const SelectContainer = styled.div`
  width: ${ResponsiveW(88)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: ${ResponsiveH(72)};
  height: ${ResponsiveH(570)};
  margin-right: 32px;
  
  @media (${device.tablet}) {
    width: auto;
    margin-right: 0;
    flex-direction: row;
    margin-top: 45px;
    height: auto;
    margin-bottom: 45px;
  }
  @media (${device.mobileL}) {
    margin-top: 18px;
    overflow-x: auto;
    height: auto;
    padding-bottom: 20px;
  }
`;

export const ModelItem = styled.div<{ image: string, active?: boolean, themeColor: string }>`
  width: ${ResponsiveW(88)};
  height: ${ResponsiveW(88)};
  border-radius: 50%;
  position: relative;
  flex: 0 0 auto;
  border: ${ResponsiveW(4)} solid transparent;
  cursor: pointer;
  
  &:not(:last-child) {
    //margin-bottom: 43px;
  }
  
  ${props => props.active ? css`
    background-color: ${props.themeColor == 'black'?'#2e2e2e':SECONDARY_COLOR_6};
    border-bottom: ${ResponsiveW(4)} solid ${PRIMARY_COLOR};
  ` : ''}
  
  &:hover {
    background-color: ${SECONDARY_COLOR_6};
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(${props => props.image}) center / ${ResponsiveW(52)} ${ResponsiveW(56)} no-repeat;
  }
  
  @media (${device.tablet}) {
    width: 134px;
    height: 134px;
    border: 4px solid transparent;

    &:after {
      background: url(${props => props.image}) center / 94px 102px no-repeat;
    }
    ${props => props.active ? css`
      border-bottom: 4px solid ${PRIMARY_COLOR};
    ` : ''}
  }
  
  @media (${device.mobileL}) {
    width: calc(((100vw - 32px) / 3) - 16px);
    height: calc(((100vw - 32px) / 3) - 16px);
    margin-right: 16px;
    &:after {
      background: url(${props => props.image}) center / 64px 69px no-repeat;
    }
  }
`;

export const TextContainer = styled.div<{ themeColor: string }>`
  position: absolute;
  left: 12%;
  top: 0;
  padding-left: 88px;
  display: flex;
  height: 100%;
  justify-content: center;
  flex-direction: column;
  width: ${ResponsiveW(400)};
  z-index: 2;
  
  > ${Button.PrimaryButton} {
    padding: 14px 16px;
    width: 200px;
    
    @media (${device.tablet}) {
      padding: 15px 35px;
      width: auto;
    }
    @media (${device.mobileL}) {
      font-size: ${TITLE_SIZE_5}px;
      padding: 4px 15px;
      line-height: 24px;
      width: auto;
    }
  }
  
  > p {
    font-size: ${ResponsiveH(TITLE_SIZE_4)};
    line-height: 150%;
    margin-top: 16px;
    margin-bottom: 56px;
    font-family: ${FAMILY_FONT_CONTROL};
  }
  > h1 {
    font-size: ${ResponsiveH(TITLE_SIZE_1)};
    letter-spacing: 0.005em;
    line-height: 130%;
    margin: 0;
    text-transform: uppercase;
    
    > span{
      color:${props => props.themeColor == 'black'?'#ffffff':SECONDARY_COLOR_1};
      display:block;
      font-size: ${ResponsiveH(TITLE_SIZE_2)};
    
      @media (${device.tablet}) {
        display:block;
        margin-left:0;
      }

      @media (${device.mobileL}) {
        font-size: ${ResponsiveH(TITLE_SIZE_4)};
      }
  }
  }

  @media (${device.tablet}) {
    position: static;
    width: 100%;
    margin-top: 48px;
    padding-left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    
    > p {
      display: none;
    }
    
    > h1 {
      font-size: ${TITLE_SIZE_1}px;
      width: 42%;

      > span{
        font-size:${TITLE_SIZE_1}px;
      }
    }
  }
  
  @media (${device.mobileL}) {
    margin-top: 24px;
    align-items: center;
    flex: 0 0 auto;
    height: auto;
    > h1 {
      width: 50%;
      font-size: ${TITLE_SIZE_4}px;
      font-weight: normal;

      > span{
        font-size:${TITLE_SIZE_4}px;
      }
    }
  }
  
`;

export const SplashScreen = styled.div<{ poster: string, themeColor: string }>`
  height: 100vh;
  background: ${props => props.themeColor == 'black'? START_PAGE_COLOR_DARK : SECONDARY_COLOR_6} linear-gradient(44.16deg, rgba(16, 203, 165, 0.13) -12.73%, rgba(16, 203, 165, 0) 28.73%);
  position: relative;
  margin: -${CONTAINER_PADDING}px -${CONTAINER_PADDING}px -${CONTAINER_PADDING}px 0;
  flex: 1 1 90%;
  border-radius: 40px 0 0 40px;
  overflow: hidden;
  
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: url("${props => props.poster}") 100% 0 / auto 100% no-repeat;
  }
  
  @media (${device.tablet}) {
    flex: 0 0 543px;
    height: 543px;
    border-radius: 26px;
    flex-direction: row;
    margin: 0;
  }
  @media (${device.mobileL}) {
    flex: 2 0 312px;
    margin: 0 -16px;
    //height: 312px;
  }
`;
